<!--
コース一覧  
-->
<template>
  <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
    <input type="radio" v-model="mode" value="horizontal" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked>
    <label class="btn btn-outline-primary" for="btnradio1">水平</label>

    <input type="radio" v-model="mode" value="vertical" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
    <label class="btn btn-outline-primary" for="btnradio2">垂直</label>

    <input type="radio" v-model="mode" value="grid" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off">
    <label class="btn btn-outline-primary" for="btnradio3">グリッド</label>
  </div>

  <h4 class="container-xxl my-4">
    コース一覧
  </h4>

  <div class="container-xxl my-4 d-flex align-items-center">
    <span>状態:</span>
    <div class="btn-group ms-2">
      <input id="status_now" type="radio" class="btn-check" name="status" checked />
      <label for="status_now" class="btn btn-outline-primary">未受講・受講中</label>
      <input id="status_completed" type="radio" class="btn-check" name="status" />
      <label for="status_completed" class="btn btn-outline-primary">完了</label>
    </div>
  </div>

  <div class="container-xxl my-4">
    <button class="btn btn-outline-primary" data-bs-toggle="collapse" data-bs-target="#filter_container">
      <svgicon name="funnel"></svgicon>
      フィルタ
    </button>
    <div id="filter_container" class="collapse row row-cols-1 row-cols-md-2 flex-wrap py-4 my-4 border-top border-bottom">
      <section class="d-flex flex-column justify-content-end col my-2">
        <label>キーワード</label>
        <input type="text" class="form-control" />
      </section>

      <section class="d-flex flex-column justify-content-end col my-2">
        <label>受講期間</label>
        <div class="input-group">
          <input type="date" class="form-control" />
          <span class="input-group-text">～</span>
          <input type="date" class="form-control" />
        </div>
      </section>

      <section class="col-md-12 my-2 text-end">
        <button type="button" class="ms-auto btn btn-outline-primary" v-on:click="onSearchClick">{{$t("buttons.search")}}</button>
      </section>
    </div>
  </div>

  <course-list :mode="mode" :courses="courses" v-on:select="selectCourse" class="container-xxl" />
</template>

<script>
  import { defineComponent } from "vue";
  import { xhrRequest, xhrErrors } from "utils/xhr";
  import Spinner from "utils/spinner";
  import { format } from 'date-fns';
  import validationErrors from "components/base/validation_errors";

  import CourseListContainer from "components/container/course_list_container";

  const onInit = () => {

  };

  const onMounted = function () {
  };

  const methods = {
    selectCourse(id) {
      console.log(id);
      window.location = `/Courses/Details?id=${id}`;
    },
  };

  const computed = {
  };

  export default defineComponent({
    data: () => {
      return {
        mode: "horizontal",
        courses: [
          {
            id: 1,
            name: "カテゴリ（分類） No.1",
            progress: 75,
            overview: "カテゴリ（分類） No.1 の概要です。",
            level: 0,
            option: {
              iconColorId: 1,
              startAt: "2022/4/1 0:00:00",
              endAt: "2022/4/1 0:00:00",
            },
            courses: [
              {
                id: 1,
                name: "コース No.1 - 1",
                progress: 60,
                overview: "コース No.1 - 1 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 1,
                    name: "チャプター（章） No.1 - 1 - 1",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 1 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 2,
                    name: "チャプター（章） No.1 - 1 - 2",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 1 - 2 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 3,
                    name: "チャプター（章） No.1 - 1 - 3",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 1 - 3 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 4,
                    name: "チャプター（章） No.1 - 1 - 4",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 1 - 4 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 5,
                    name: "チャプター（章） No.1 - 1 - 5",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 1 - 5 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 6,
                    name: "チャプター（章） No.1 - 1 - 6",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 1 - 6 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 7,
                    name: "チャプター（章） No.1 - 1 - 7",
                    progress: 60,
                    overview: "チャプター（章） No.1 - 1 - 7 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 8,
                    name: "チャプター（章） No.1 - 1 - 8",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 1 - 8 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 9,
                    name: "チャプター（章） No.1 - 1 - 9",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 1 - 9 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 10,
                    name: "チャプター（章） No.1 - 1 - 10",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 1 - 10 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 11,
                    name: "チャプター（章） No.1 - 1 - 11",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 1 - 11 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 2,
                name: "コース No.1 - 2",
                progress: 100,
                overview: "コース No.1 - 2 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 12,
                    name: "チャプター（章） No.1 - 2 - 1",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 2 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 13,
                    name: "チャプター（章） No.1 - 2 - 2",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 2 - 2 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 14,
                    name: "チャプター（章） No.1 - 2 - 3",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 2 - 3 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 15,
                    name: "チャプター（章） No.1 - 2 - 4",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 2 - 4 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 16,
                    name: "チャプター（章） No.1 - 2 - 5",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 2 - 5 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 17,
                    name: "チャプター（章） No.1 - 2 - 6",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 2 - 6 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 3,
                name: "コース No.1 - 3",
                progress: 0,
                overview: "コース No.1 - 3 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 18,
                    name: "チャプター（章） No.1 - 3 - 1",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 3 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 19,
                    name: "チャプター（章） No.1 - 3 - 2",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 3 - 2 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 20,
                    name: "チャプター（章） No.1 - 3 - 3",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 3 - 3 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 4,
                name: "コース No.1 - 4",
                progress: 100,
                overview: "コース No.1 - 4 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 21,
                    name: "チャプター（章） No.1 - 4 - 1",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 4 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 5,
                name: "コース No.1 - 5",
                progress: 20,
                overview: "コース No.1 - 5 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 22,
                    name: "チャプター（章） No.1 - 5 - 1",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 5 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 23,
                    name: "チャプター（章） No.1 - 5 - 2",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 5 - 2 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 24,
                    name: "チャプター（章） No.1 - 5 - 3",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 5 - 3 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 25,
                    name: "チャプター（章） No.1 - 5 - 4",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 5 - 4 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                  {
                    id: 26,
                    name: "チャプター（章） No.1 - 5 - 5",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 5 - 5 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 6,
                name: "コース No.1 - 6",
                progress: 100,
                overview: "コース No.1 - 6 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 27,
                    name: "チャプター（章） No.1 - 6 - 1",
                    progress: 100,
                    overview: "チャプター（章） No.1 - 6 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 7,
                name: "コース No.1 - 7",
                progress: 0,
                overview: "コース No.1 - 7 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 28,
                    name: "チャプター（章） No.1 - 7 - 1",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 7 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 8,
                name: "コース No.1 - 8",
                progress: 0,
                overview: "コース No.1 - 8 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 29,
                    name: "チャプター（章） No.1 - 8 - 1",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 8 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 9,
                name: "コース No.1 - 9",
                progress: 0,
                overview: "コース No.1 - 9 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 30,
                    name: "チャプター（章） No.1 - 9 - 1",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 9 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 10,
                name: "コース No.1 - 10",
                progress: 0,
                overview: "コース No.1 - 10 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 31,
                    name: "チャプター（章） No.1 - 10 - 1",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 10 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
              {
                id: 11,
                name: "コース No.1 - 11",
                progress: 0,
                overview: "コース No.1 - 11 の概要です。",
                level: 1,
                option: {
                  iconColorId: 1,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 32,
                    name: "チャプター（章） No.1 - 11 - 1",
                    progress: 0,
                    overview: "チャプター（章） No.1 - 11 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 1,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 2,
            name: "カテゴリ（分類） No.2",
            progress: 100,
            overview: "カテゴリ（分類） No.2 の概要です。",
            level: 0,
            option: {
              iconColorId: 2,
              startAt: "2022/4/1 0:00:00",
              endAt: "2022/4/1 0:00:00",
            },
            courses: [
              {
                id: 12,
                name: "コース No.2 - 1",
                progress: 100,
                overview: "コース No.2 - 1 の概要です。",
                level: 1,
                option: {
                  iconColorId: 2,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 33,
                    name: "チャプター（章） No.2 - 1 - 1",
                    progress: 100,
                    overview: "チャプター（章） No.2 - 1 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 2,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            name: "カテゴリ（分類） No.3",
            progress: 0,
            overview: "カテゴリ（分類） No.3 の概要です。",
            level: 0,
            option: {
              iconColorId: 3,
              startAt: "2022/4/1 0:00:00",
              endAt: "2022/4/1 0:00:00",
            },
            courses: [
              {
                id: 13,
                name: "コース No.3 - 1",
                progress: 0,
                overview: "コース No.3 - 1 の概要です。",
                level: 1,
                option: {
                  iconColorId: 3,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 34,
                    name: "チャプター（章） No.3 - 1 - 1",
                    progress: 0,
                    overview: "チャプター（章） No.3 - 1 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 3,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 4,
            name: "カテゴリ（分類） No.4",
            progress: 100,
            overview: "カテゴリ（分類） No.4 の概要です。",
            level: 0,
            option: {
              iconColorId: 4,
              startAt: "2022/4/1 0:00:00",
              endAt: "2022/4/1 0:00:00",
            },
            courses: [
              {
                id: 14,
                name: "コース No.4 - 1",
                progress: 100,
                overview: "コース No.4 - 1 の概要です。",
                level: 1,
                option: {
                  iconColorId: 4,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 35,
                    name: "チャプター（章） No.4 - 1 - 1",
                    progress: 100,
                    overview: "チャプター（章） No.4 - 1 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 4,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 5,
            name: "カテゴリ（分類） No.5",
            progress: 100,
            overview: "カテゴリ（分類） No.5 の概要です。",
            level: 0,
            option: {
              iconColorId: 5,
              startAt: "2022/4/1 0:00:00",
              endAt: "2022/4/1 0:00:00",
            },
            courses: [
              {
                id: 15,
                name: "コース No.5 - 1",
                progress: 100,
                overview: "コース No.5 - 1 の概要です。",
                level: 1,
                option: {
                  iconColorId: 5,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 36,
                    name: "チャプター（章） No.5 - 1 - 1",
                    progress: 100,
                    overview: "チャプター（章） No.5 - 1 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 5,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
            ],
          },
          {
            id: 6,
            name: "カテゴリ（分類） No.6",
            progress: 0,
            overview: "カテゴリ（分類） No.6 の概要です。",
            level: 0,
            option: {
              iconColorId: 6,
              startAt: "2022/4/1 0:00:00",
              endAt: "2022/4/1 0:00:00",
            },
            courses: [
              {
                id: 16,
                name: "コース No.6 - 1",
                progress: 0,
                overview: "コース No.6 - 1 の概要です。",
                level: 1,
                option: {
                  iconColorId: 7,
                  startAt: "2022/4/1 0:00:00",
                  endAt: "2022/4/1 0:00:00",
                },
                courses: [
                  {
                    id: 37,
                    name: "チャプター（章） No.6 - 1 - 1",
                    progress: 0,
                    overview: "チャプター（章） No.6 - 1 - 1 の概要です。",
                    level: 2,
                    option: {
                      iconColorId: 8,
                      startAt: "2022/4/1 0:00:00",
                      endAt: "2022/4/1 0:00:00",
                    },
                  },
                ],
              },
            ],
          },
        ],
      }
    },
    created: onInit,
    mounted: onMounted,
    methods: methods,
    computed: computed,
    watch: {
    },
    components: {
      "course-list": CourseListContainer,
    },

  });
</script>
